import { Component, Input, OnChanges, OnDestroy, OnInit, Inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs/Subject';
import { Area } from 'OpsCenter/merchant-tools/models/area';
import { MigrationToolService } from 'OpsCenter/merchant-tools/migration-form/services/migration-tool.service';
import { MigrationRequest } from 'OpsCenter/merchant-tools/models/migration-request';
import { MerchantToolType } from 'OpsCenter/merchant-tools/models/merchant-tool-type';
import { Table } from 'OpsCenter/merchant-tools/models/table';
import { IntegrationPartnerRequest } from 'OpsCenter/merchant-tools/models/integration-partner-request';

@Component({
  selector: 'app-merchant-tools',
  template: require('./merchant-tools.component.html'),
  styles: [require('./merchant-tools.component.scss')],
})
export class MerchantToolsComponent implements OnInit, OnDestroy {
  @Input() merchant: any;
  @Input() currentIntegrationMigrationStatus: any;
  @Input() integrationPartnerSources: any[];
  @Input() integrationPartnerSubSources: any[];

  public areas: Area[] = [];
  public tables: Table[] = [];
  public merchantToolType = MerchantToolType;
  public selectedTab: MerchantToolType = MerchantToolType.AREA_MIGRATION;
  public requestedSuccessfully = false;
  private destroy$ = new Subject();
  public errorMessage: string | null = null;

  constructor(
    private migrationService: MigrationToolService,
    private notificationService: ToastrService,
    @Inject('$scope') private $scope: any
  ) {}
  ngOnInit(): void {
    this.$scope.$on('merchant.tab.tools.selected', (event, data) => {
      this.merchant = data.merchant;
      this.integrationPartnerSources = data.externalPartnerSources;
      this.integrationPartnerSubSources = data.externalPartnerSubSources;
      this.currentIntegrationMigrationStatus = data.currentIntegrationMigrationStatus;
      this.$scope.$apply();
    });
  }

  // ngOnChanges(changes: any): void {
  //   if (changes.currentIntegrationMigrationStatus) {
  //     console.log('currentIntegrationMigrationStatus changes', this.currentIntegrationMigrationStatus);
  //   }
  // }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onAreaMigrationSubmit(requestBody: MigrationRequest) {
    this.migrationService
      .changeArea(this.merchant.id, requestBody)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => {
          this.requestedSuccessfully = true;
        },
        error => {
          const message = this.handleMessage(error.error.errors[0].message);
          this.handleError(message);
        }
      );
  }

  onIntegrationPartnerSubmit(requestBody: IntegrationPartnerRequest) {
    this.migrationService
      .startIntegrationPartnerMigration(
        this.merchant.publicId,
        requestBody.selectedIntegrationPartnerSource,
        requestBody.externalId,
        requestBody.subSource
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        response => {
          this.requestedSuccessfully = true;
        },
        error => {
          const message = this.handleMessage(error.message);
          this.errorMessage = error.message;
          if (error.message) {
            this.errorMessage = error.message;
          }
          if (error.erros) {
            this.errorMessage = error.errors[0].developerMessage;
          }
          this.handleError(message);
        }
      );
  }

  onReservationMigrationSubmit(requestBody: any) {
    this.migrationService
      .changeTable(this.merchant.id, requestBody)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => {
          this.requestedSuccessfully = true;
        },
        error => {
          const message = this.handleMessage(error.error.errors[0].message);
          this.handleError(message);
        }
      );
  }

  onSwitchTab(tab: MerchantToolType): void {
    this.selectedTab = tab;
    this.reset();
  }

  getTablesFromArea(areaId: number) {
    this.migrationService
      .getTablesFromArea(this.merchant.id, areaId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(tables => {
        this.tables = tables;
      });
  }

  private handleError(message: string): void {
    this.notificationService.error(message);
  }

  private handleMessage(error: string): string {
    if (error.includes('in the past')) {
      return 'Start date cannot be in the past. Please choose a start date in the future.';
    } else if (error.includes('after end')) {
      return 'End date cannot be before start date. Please choose an end date after start date.';
    }
    return 'Oops, something went wrong. Please try again later';
  }

  private reset(): void {
    this.requestedSuccessfully = false;
    this.tables = [];
  }
}





// WEBPACK FOOTER //
// ./src/app/merchant-tools/merchant-tools.component.ts